import {merge} from '#core/utils/config-utils.js';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {getBaseComponentsConfig} from './style/base-components';
import {getMyAccountConfigs} from './style/account';
import {getMenuListsConfigs} from './style/menus-links-lists';
import {getBetHistoryConfigs} from './style/bethistory';
import {getBettingCenterConfig} from './style/betting-center';
import {getBonusesConfig} from './style/bonuses';
import {getCardsConfigs} from './style/cards';
import {getDialogsConfigs} from './style/dialogs';
import {getMarketsConfigs} from './style/markets';
import {getMatchAccaConfigs} from './style/matchacca';
import {getPageHeadersConfigs} from './style/interface';
import {getRacingConfigs} from './style/racing';
import {getStaticPagesConfigs} from './style/static-pages';
import {getVirtualsConfigs} from './style/virtuals';
import {getSportsContentConfigs} from './style/sports-content';
import {COLOR, FONT} from './theme.js';

export function getTokens() {
    const TILE_FONT = Object.assign({}, FONT);
    delete TILE_FONT.FAMILY_SECOND;

    const tokens = merge(
        {
            custom: {
                [PALETTE_IDS.SCOREBOARDS]: {
                    Scoreboard: {
                        backgroundImages: {
                            esports: 'card-background/scoreboard_bg_e_sports.png',
                            martial_arts: 'card-background/scoreboard_bg_ufc.png',
                        },
                    },
                },
            },
            palette: {
                [PALETTE_IDS.FONT]: TILE_FONT,
                [PALETTE_IDS.MOBILE_NAVBAR]: {
                    CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                    ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                    LABEL_TEXT: {
                        textTransform: 'uppercase',
                        color: COLOR.BRAND.FOREGROUND3,
                    },
                },
                [PALETTE_IDS.SEARCH_RESULT]: {
                    SEARCH_RECENT_ITEM_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                    SEARCH_RECENT_ITEM_TEXT: COLOR.BRAND.FOREGROUND1,
                    SEARCH_RECENT_ITEM_REMOVE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,

                    SEARCH_RESULT_ITEM_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                    SEARCH_RESULT_ITEM_TOURNAMENT_TEXT: COLOR.BRAND.FOREGROUND2,
                    SEARCH_RESULT_ITEM_NAME_TEXT: {
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        color: COLOR.BRAND.FOREGROUND1,
                    },
                    SEARCH_RESULT_ITEM_STATUS_TEXT: COLOR.BRAND.FOREGROUND1,
                },
                [PALETTE_IDS.SEARCH]: {
                    SEARCH_OVERLAY_BG: COLOR.BRAND.BACKGROUND4,
                },
                [PALETTE_IDS.SCOREBOARDS]: {
                    SCOREBOARD_CONTAINER_BG: COLOR.BRAND.BACKGROUND6,
                    TIMING_STATUS_LABEL: {
                        EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND3,
                        EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND3,
                    },
                    PARTICIPANT_NAME_TEXT: {
                        fontSize: FONT.SIZE_MEDIUM,
                        color: COLOR.BRAND.FOREGROUND5,
                    },
                    SEGMENT_TEXT: COLOR.BRAND.FOREGROUND3,
                    SEGMENT_TOTAL_TEXT: COLOR.BRAND.ACCENT2,
                    SEGMENT_TOTAL_HEADER_TEXT: COLOR.BRAND.FOREGROUND5,
                    SEGMENT_HEADER_TEXT: COLOR.BRAND.FOREGROUND5,
                },
                [PALETTE_IDS.VIDEO_STREAMING]: {
                    VIDEO_STREAMING_CONTAINER_BG: COLOR.RESERVED.BLACK,
                    VIDEO_STREAMING_STATUSBAR_TEXT: {
                        color: COLOR.BRAND.FOREGROUND5,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                },
                [PALETTE_IDS.SKELETON]: {
                    SKELETON_COLOR: COLOR.BRAND.FOREGROUND6,
                },
                [PALETTE_IDS.INPUT]: {
                    INPUT_BG: COLOR.RESERVED.TRANSPARENT,
                    INPUT_BORDER_COLOR: COLOR.BRAND.FOREGROUND4,
                    INPUT_TEXT: COLOR.BRAND.FOREGROUND4,
                    INPUT_LABEL_TEXT: COLOR.BRAND.FOREGROUND4,
                    INPUT_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
                    INPUT_PLACEHOLDER_TEXT: COLOR.BRAND.FOREGROUND3,

                    INPUT_FOCUSED_BORDER_COLOR: COLOR.BRAND.ACCENT2,
                },
                [PALETTE_IDS.STAKE_INPUT]: {
                    STAKE_INPUT_TEXT: {
                        color: COLOR.BRAND.FOREGROUND4,
                        fontWeight: FONT.WEIGHT_NORMAL,
                    },
                    STAKE_INPUT_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
                    STAKE_INPUT_BORDER_COLOR: COLOR.BRAND.FOREGROUND2,
                    STAKE_INPUT_FOCUSED_BORDER_COLOR: COLOR.BRAND.ACCENT2,
                },
                [PALETTE_IDS.RANGE_INPUT]: {
                    RANGE_TRACK_COLOR: COLOR.BRAND.FOREGROUND3,
                    RANGE_TRACK_FILLED_COLOR: COLOR.BRAND.FOREGROUND1,
                    RANGE_THUMB_COLOR: COLOR.BRAND.FOREGROUND1,
                    RANGE_TRACK_DISABLED_COLOR: COLOR.BRAND.FOREGROUND6,
                    RANGE_THUMB_DISABLED_COLOR: COLOR.BRAND.FOREGROUND6,
                    RANGE_TRACK_DISABLED_FILLED_COLOR: COLOR.BRAND.FOREGROUND6,
                    RANGE_LABEL_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                [PALETTE_IDS.INFO_NOTIFICATION]: {
                    INFO_BG: COLOR.BRAND.FOREGROUND6,
                    INFO_TEXT: COLOR.BRAND.FOREGROUND2,
                    INFO_ICON_COLOR: COLOR.BRAND.FOREGROUND3,
                    INFO_BORDER_COLOR: COLOR.BRAND.FOREGROUND3,
                },
                [PALETTE_IDS.EMPTY_CONTENT_MESSAGE]: {
                    EMPTY_CONTENT_MESSAGE_TEXT: COLOR.BRAND.FOREGROUND2,
                },
                [PALETTE_IDS.SWITCH]: {
                    SWITCH_CONTAINER_BG: COLOR.RESERVED.TRANSPARENT,
                    SWITCH_CONTAINER_BORDER_COLOR: COLOR.BRAND.FOREGROUND1,
                    SWITCH_BUTTON_BG: COLOR.BRAND.FOREGROUND1,
                    SWITCH_ICON_COLOR: COLOR.BRAND.FOREGROUND7,
                    SWITCH_LABEL_TEXT: COLOR.BRAND.FOREGROUND1,
                    SWITCH_DISABLED_CONTAINER_BORDER_COLOR: COLOR.BRAND.FOREGROUND2,
                    SWITCH_DISABLED_BUTTON_BG: COLOR.BRAND.FOREGROUND2,
                    SWITCH_DISABLED_LABEL_TEXT: COLOR.BRAND.FOREGROUND2,
                },
            },
        },
        getBaseComponentsConfig(),
        getMyAccountConfigs(),
        getMenuListsConfigs(),
        getBetHistoryConfigs(),
        getBettingCenterConfig(),
        getBonusesConfig(),
        getCardsConfigs(),
        getDialogsConfigs(),
        getMarketsConfigs(),
        getMatchAccaConfigs(),
        getPageHeadersConfigs(),
        getRacingConfigs(),
        getStaticPagesConfigs(),
        getVirtualsConfigs(),
        getSportsContentConfigs()
    );

    return tokens;
}
